<template>
  <div>
    site = {{ this.$store.state.site_name }}
  </div>
</template>

<script>
import axios from 'axios';
import viewMixin from '../mixins/viewMixin';

export default {
  mixins: [viewMixin],
  name: 'Home',
  props: ['title', 'description'],
  created() {
    // this.checkCORS();
  },
  methods: {
    checkCORS() {
      axios({
        method: 'POST',
        url: 'https://api.sites.uecloud.net/v1/edu-search',
      })
        .then((response) => {
          console.log('RESPONSE: ', response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
